<template>
  <div class="act-half-screen-dialog" v-if="!isDynamicLoad || isLoad">
    <FitHalfScreenDialog
      :visible="isShow"
      @onClose="hideDialog"
      :title="title"
      :closeAriaLabel="closeAriaLabel"
      :tabIndex="tabIndex"
      :maskClose="isCloseOnClickMask"
      :hideHeader="isHideHeader"
      :isShowClose="isShowClose"
      :isShowMask="isShowMask"
    >
      <slot name="hd" slot="hd" v-if="$slots.hd"></slot>
      <!-- body -->
      <slot name="bd"></slot>
      <!-- footer -->
      <slot name="ft"></slot>
    </FitHalfScreenDialog>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { FitHalfScreenDialog } from '@tencent/wphk-ui';

/** 半屏弹窗组件
 * 打开时才创建DOM，关闭时会自动销毁弹窗DOM
 * 以提高性能(maybe)
 */
@Component({
  components: {
    FitHalfScreenDialog,
  },
})
export default class FitHalfScreenDialogV2 extends Vue {
  /** 标题 */
  @Prop({ default: '' }) title!: string;
  /** 关闭按钮提示文案 */
  @Prop({ default: '關閉' }) closeAriaLabel!: String;
  /** tab键序号 */
  @Prop({ default: -1 }) tabIndex!: Number;
  /** 点击遮罩层是否关闭 */
  @Prop({ default: true }) isCloseOnClickMask!: boolean;
  /** 是否隐藏标题区域 */
  @Prop({ default: false }) isHideHeader!: boolean;
  /** 是否挂载到body中 */
  @Prop({ default: false }) isAppendToBody!: boolean;
  /** 是否展示关闭按钮 */
  @Prop({ default: true }) isShowClose!: boolean;
  @Prop({ default: true }) isShowMask!: boolean;
  /** 是否动态加载到dom中 */
  @Prop({ default: true }) isDynamicLoad!: boolean;
  /** 是否展示 */
  public isShow = false;
  /** 是否加载（至DOM） */
  public isLoad = false;

  public showDialog() {
    this.isLoad = true;
    setTimeout(() => {
      this.isShow = true;
    }, 200);
  }
  @Emit('onClose')
  public hideDialog() {
    this.isShow = false;
    setTimeout(() => {
      this.isLoad = false;
    }, 300);
  }
  mounted() {
    if (this.isAppendToBody) {
      document.body.appendChild(this.$el);
    }
  }
  destroyed() {
    if (this.isAppendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
}
</script>
